import { message } from "antd"
import { domainUrl } from "../../constants"
import { checkAuthorization } from "../../helpers"

const getService= ()=>{
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers()
    myHeaders.append('Authorization', userToken)
    return (
        fetch(domainUrl + "/getAllServices", {
            method: "GET",
            headers: myHeaders
        })
        .then(response => response.json())
        .then(result => {
            if (result?.success) 
                return result?.data
            else
                throw result?.message
        })
        .catch(error => {
            message.error(error)
            return 0
        })
    )
}

const serviceApi = {
    getService,
};

export { serviceApi };